import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import apis from "../services";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useErrorModal } from "../contexts/ErrorModalContext";

const VaultCard = ({ item }) => {
  const [isFavorite, setIsFavorite] = useState(item.is_favourite === 1);

  const liquidity = isNaN(parseFloat(item.liquidity))
    ? 0
    : parseFloat(item.liquidity);
  const price = isNaN(parseFloat(item.price)) ? 0 : parseFloat(item.price);
  const fdv = isNaN(parseFloat(item.fdv)) ? 0 : parseFloat(item.fdv);
  const trustScore = isNaN(parseFloat(item.score)) ? 0 : parseFloat(item.score);

  const navigate = useNavigate();

  const handleRowClick = (e, address, chainName) => {
    if (chainName.toLowerCase() === "solana") {
      return;
    }

    if (e.target.closest(".coin-name")) {
      navigate(`/details/${address}?chainName=${chainName}`);
    }
  };

  const userId = localStorage.getItem("userId");
  const filters = [
    { chainName: "all" },
    { age: "all" },
    { score: "all" },
    { liquidity: "all" },
    { volume: "all" },
  ];

  const { showError } = useErrorModal();

  const handleToggleFavorite = async () => {
    try {
      const favoriteBody = {
        itemId: item.id,
        type: "DEX",
        userId: userId,
        price: item.price,
      };

      console.log(item, "items-items");

      const favoriteResponse = await apis.favourite(favoriteBody);

      if (favoriteResponse.success) {
        toast.success(
          favoriteResponse.message || "Action completed successfully."
        );
      } else {
        toast.error(favoriteResponse.message || "Something went wrong.");
      }

      const alltoken = await apis.alltoken(filters);
      const fetchtop = await apis.fetchtop(filters);

      console.log(
        alltoken.tokenDetails.find((token) => token.id === item.id),
        "All Token"
      );

      console.log(
        fetchtop?.tokenDetails.find((token) => token.id === item.id),
        "Fetch Details"
      );

      if (alltoken || fetchtop) {
        const newIsFavoriteAllToken = alltoken?.tokenDetails.find(
          (token) => token.id === item.id
        )?.is_favourite;

        console.log(newIsFavoriteAllToken, "newIsFavoriteAllToken");

        const newIsFavoriteFetchTop = fetchtop?.tokenDetails.find(
          (token) => token.id === item.id
        )?.is_favourite;

        console.log(newIsFavoriteFetchTop, "newIsFavoriteAllToken");

        const newIsFavorite =
          newIsFavoriteAllToken !== undefined
            ? newIsFavoriteAllToken
            : newIsFavoriteFetchTop;

        if (newIsFavorite !== undefined) {
          setIsFavorite(newIsFavorite === 1); // Set the favorite state to true or false
        } else {
        }
      } else {
        console.log("No tokens found.");
      }
    } catch (error) {
      showError(error.message);
      console.error("Error toggling favorite:", error);
      // toast.error("Something went wrong, please try again.");
    }
  };

  return (
    <div
      className={`vault-card ${isFavorite ? "highlighted" : ""}`}
      style={isFavorite ? {} : {}}
    >
      <div className="card-header">
        <h3
          className="card-title coin-name"
          style={{ cursor: "pointer" }}
          onClick={(e) => handleRowClick(e, item.tokenAddress, item.chainName)}
        >
          {item.CoinName}
        </h3>

        <button
          onClick={handleToggleFavorite}
          style={{
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0",
          }}
        >
          <img
            src={isFavorite ? "/likered.svg" : "/unlike.svg"}
            alt={isFavorite ? "Unlike" : "Like"}
            style={{
              width: "18px",
              height: "18px",
              marginLeft: "8px",
              transition: "transform 0.3s ease",
              transform: isFavorite ? "scale(1.1)" : "scale(1)",
            }}
          />
        </button>
      </div>

      <div className="card-details">
        <div className="detail-row">
          <span className="detail-label">Liquidity:</span>
          <span className="detail-value" style={{ color: "#22C55E" }}>
            ${liquidity}
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Price:</span>
          <span className="detail-value">${price}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">FDV:</span>
          <span className="detail-value">${fdv}</span>
        </div>
      </div>

      <div className="card-footer">
        <div className="trust-score">
          <span className="trust-score-label">Trust Score:</span>
          <div className="trust-score-value">
            <span className="trust-score-value">{trustScore}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

VaultCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    CoinName: PropTypes.string.isRequired,
    tokenAddress: PropTypes.string.isRequired,
    chainName: PropTypes.string.isRequired,
    liquidity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fdv: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    is_favourite: PropTypes.number,
  }).isRequired,
};

export default VaultCard;
